import gql from 'graphql-tag';


export const getJobDetails = gql`
subscription  getjobbyid($id: uuid) {
    jobs( where: {_and: [{id: {_eq: $id}}]}) {
      id   
     title
      j_type
      j_role
      description
      TypeofEmployment
      years_of_experience
      dental_practice_id
      dental_supplier_id
      active_status
      location
      logo
      state
      city
      salary
      company_name
      website_url
      pay_range
      education
      video  
      closed_at
      status
      offered_benefits
      country
      endDateToggle
      pay_max
      pay_min
      hiring_period
      no_of_people
      rate_billing
      linkedin_url
      instagram_url
      facebook_url
      clinic_logo
      timings
      banner_image
      timingtoggle
      created_at
      
    }
    }
`;


export const applyJob = gql`
mutation insert_jobapplicants($applyJobobject:job_applicants_insert_input!) {
  insert_job_applicants_one(object: $applyJobobject) {
    id
  }
}
`
export const addAppliedMessageMutation = gql`mutation insert_message_one($object:job_applicant_messages_insert_input!){
  insert_job_applicant_messages_one(object:$object){
    id
  }
}`;


export const selectedcompanyInfo = gql`
  query getCompany($loginid: uuid!) {
    directories(
      where: {
        _or: [
          { dental_supplier_id: { _eq: $loginid } },
          { dental_practice_id: { _eq: $loginid } }
        ]
      }
    ) {
      id
      name
      email
      logo
      profile_image
      company_name
      type
      profession_type
      description
      directoryFollowersByFollowerDentalCompanyId {
        following_status
      }
    }
  }
`;

export const getJobProfileInfo = gql`subscription getprofilesData($id:uuid) {  
  job_profiles( where: {dental_professional_id:{_eq: $id}}) {
  post_anonymously
    jobexperiences
    skills
    upload_resume
    current_company
    current_ctc
    job_designation
    job_location
    created_at
    updated_at
    dental_professional_id
    id
    email_address
    full_name
    mobile_number

 }}`



export const addEnquiryMutation = gql`mutation insert_Enquiry_one($object:job_enquiries_insert_input!){
   insert_job_enquiries_one(object:$object){
     id
   }
 }`;


export const addTalentEnquiryMutation = gql`mutation insert_Enquiry_one($object:talent_enquiries_insert_input!){
   insert_talent_enquiries_one(object:$object){
     id
   }
 }`;
